<script setup lang="ts">
  import { differenceInDays } from 'date-fns'
  import { computed } from 'vue'

  const props = defineProps<{
    createdAt: string,
  }>()

  const show = computed(() => differenceInDays(new Date(), props.createdAt) < 1)
</script>

<template>
  <span :class="[show ? 'text-xs ml-1 text-primary-500' : 'hidden']">
    NEW
  </span>
</template>
